<div class="container">
  <div class="row">
    <div class="col-md-6">
      <div class="ask-me">
        <div class="ask-me__card">
          <div class="ask-me__card--body">
            <div class="ask-me__card--body__title">Questions</div>
            <div class="ask-me__card--body__desc">
              Engage with the community by asking and answering questions. Share your knowledge and get insights from
              others.
            </div>
          </div>
          <div class="ask-me__card--footer">
            <div class="grid">
              <div class="text">Questions</div>
              <!-- <button
                class="btn-grid"
                (click)="viewGrid = true"
                [ngClass]="{ active: viewGrid }"
              >
                <i class="fa-solid fa-grip-vertical"></i>
              </button>
              <button
                class="btn-grid"
                (click)="viewGrid = false"
                [ngClass]="{ active: !viewGrid }"
              >
                <i class="fa-solid fa-list"></i>
              </button> -->
            </div>
            <button class="button-2" (click)="openShopPopup(0)">Add Ask</button>
          </div>
        </div>
        <app-ask-carsouel [title]="false" [grid]="viewGrid" #Ask></app-ask-carsouel>
        <!-- <app-ask
          [title]="false"
          gridNumber="3"
          [grid]="viewGrid"
          #Ask
          [viewMode]="true"
        ></app-ask> -->
      </div>
      <div class="news-me">
        <div class="news-me__card">
          <div class="news-me__card--body">
            <div class="news-me__card--body__title">News</div>
            <div class="news-me__card--body__desc">
              Stay updated with the latest community news and announcements. Explore new features and improvements.
            </div>
          </div>
          <div class="news-me__card--footer">
            <div class="news-me__card--footer__title">News</div>
            <button class="button-2" routerLink="/news">Add Post</button>
          </div>
        </div>
        <community-articles-carsouel [carouselOptions]="carousel" [title]="false" grid="4"
          #communityArticles></community-articles-carsouel>

      </div>
    </div>
    <div class="col-md-6">
      <div class="news-me">
        <div class="news-me__card">
          <div class="news-me__card--body">
            <div class="news-me__card--body__title">Recommend</div>
            <div class="news-me__card--body__desc">
              Recommend good Lobangs in your area to your Neighbours and be rewarded.
            </div>
          </div>
          <div class="news-me__card--footer">
            <div class="news-me__card--footer__title">Recommend</div>
            <button class="button-2" (click)="openAddRecommendationForm()">Add Recommend</button>
          </div>
        </div>
        <div class="recomms">
          <app-my-carousel-swiper [config]="carouselOptions">
            <div *ngFor="let recomm of myRecommendations" class="swiper-slide recomm-card">
              <div style="position: relative">
                <!-- <button class="controls p-1" (click)="recomm.isPopupOpen = !recomm.isPopupOpen" style="font-size: 1.1rem">
                <i class="fa-solid fa-ellipsis-v text-dark"></i>
                <div class="controls-dropdown" *ngIf="recomm.isPopupOpen">
                  <button (click)="editRecommendation(recomm)"><i class="fa fa-pen"></i> <span>Edit</span></button>
                  <button (click)="deleteRecomm(recomm)"><i class="fa fa-trash"></i> <span
                      style="color: purple">Delete</span></button>
                </div>
              </button> -->

                <div class="name">
                  {{ recomm.nameOfServiceProvider }}
                </div>
                <div>
                  {{ recomm.company }}
                </div>
                <div class="selling-points">
                  <div class="message">
                    <i class="fa-solid fa-arrow-right mr-1"></i>
                    <span>{{ recomm.uniqueSellingPointOne | slice : 0 : 50 }}</span>
                  </div>

                  <div class="message" *ngIf="recomm.uniqueSellingPointTwo">
                    <i class="fa-solid fa-arrow-right mr-1"></i>
                    <span>{{ recomm.uniqueSellingPointTwo | slice : 0 : 50 }}</span>
                  </div>
                </div>
              </div>

              <div>
                <div class="company">
                  <img *ngIf="recomm.imageLocation" loading="lazy" src="{{ imageUrl + recomm.imageLocation }}" alt="" />
                  <span *ngIf="!recomm.imageLocation" style="width: 1px"></span>
                  <div class="number">
                    {{ recomm.phone }}
                  </div>
                </div>

                <div class="recomm-card__footer">
                  <button (click)="like(recomm)">{{ recomm.likeCounts }} <i class="fa fa-thumbs-up"></i></button>
                </div>
              </div>
            </div>
          </app-my-carousel-swiper>
        </div>
      </div>
    </div>
  </div>
</div>